module.exports = __webpack_public_path__ + "media/fonts/suisse-intl/SuisseIntl-Regular-WebXL-64d7bd55cab96b676cc4ab2cf89c717e.woff2";